import {
  filter_styles_default
} from "./chunk.MN4HJ5Z6.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/filter/filter.ts
import { t as t2 } from "i18next";
var FadvFilter = class extends s {
  constructor() {
    super(...arguments);
    this.panelSize = "small";
    this.buttonSize = "small";
    this.open = false;
  }
  get menu() {
    var _a, _b;
    return (_b = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector("slot")) == null ? void 0 : _b.assignedElements({ flatten: true })[0];
  }
  firstUpdated() {
    const menu = this.menu;
    if (menu)
      menu.classList.add("filter-menu");
  }
  handleDropdownStateChange(event) {
    const target = event.target;
    this.open = target.open;
  }
  getFilterValuesByCategory() {
    var _a, _b;
    const selections = {};
    const menuItems = ((_b = (_a = this.menu) == null ? void 0 : _a.shadowRoot) == null ? void 0 : _b.children[0].querySelector("slot.menu__container")).assignedElements({
      flatten: true
    });
    let currentCategory = "";
    for (const menuItem of menuItems) {
      if (hasTag(menuItem, "fadv-menu-category")) {
        currentCategory = menuItem.value;
        continue;
      }
      if (!menuItem.checked)
        continue;
      if (!selections[currentCategory])
        selections[currentCategory] = [menuItem.value];
      else
        selections[currentCategory].push(menuItem.value);
    }
    return selections;
  }
  render() {
    return $`<fadv-dropdown id="filter" class=${o({
      filter: true,
      "filter--open": this.open
    })} hoist size=${this.panelSize} skidding="5" distance="10" placement="bottom-end" @sl-show=${this.handleDropdownStateChange} @sl-hide=${this.handleDropdownStateChange} stay-open-on-select ><button slot="trigger" class=${o({
      filter__trigger: true,
      "filter__trigger--small": this.buttonSize === "small",
      "filter__trigger--medium": this.buttonSize === "medium",
      "filter__trigger--large": this.buttonSize === "large"
    })} ><fadv-icon class="filter__open-icon" library="solid" name="fa-filter" label=${t2("components:filter.openFilter")}></fadv-icon><fadv-icon class="filter__close-icon" library="solid" name="fa-xmark" label=${t2("components:filter.closeFilter")}></fadv-icon></button><slot></slot></fadv-dropdown>`;
  }
};
FadvFilter.styles = filter_styles_default;
__decorateClass([
  e()
], FadvFilter.prototype, "panelSize", 2);
__decorateClass([
  e()
], FadvFilter.prototype, "buttonSize", 2);
__decorateClass([
  t()
], FadvFilter.prototype, "open", 2);
FadvFilter = __decorateClass([
  n("fadv-filter")
], FadvFilter);

export {
  FadvFilter
};
